import React from "react";
import {
    Box,
    FormControl,
    FormLabel,
    Input,
    Textarea,
    Select,
    Button,
    Tag,
    TagLabel,
    TagCloseButton,
    Flex,
    Text,
} from "@chakra-ui/react";

export const VimeoUploadForm = ({ formData, tagInput, updateTagInput, handleChange, handleFileChange, addTag, removeTag }) => {

    return (
        <Box maxWidth="600px" mx="auto">
            <Text margin="0 0 10px">Uploading a video allows us to automatically extract the voiceover, enabling the creation of EdDocs with interactive transcripts and content.</Text>
            <FormControl isRequired mb={4}>
                <FormLabel>Title</FormLabel>
                <Input
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    placeholder="Enter video title"
                />
            </FormControl>

            <FormControl mb={4}>
                <FormLabel>Description</FormLabel>
                <Textarea
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    placeholder="Enter video description"
                />
            </FormControl>

            <FormControl mb={4}>
                <FormLabel>Tags</FormLabel>
                <Flex mb={2} gap={2} wrap="wrap">
                    {formData.tags.map((tag, index) => (
                        <Tag key={index} size="md" colorScheme="blue">
                            <TagLabel>{tag}</TagLabel>
                            <TagCloseButton onClick={() => removeTag(tag)} />
                        </Tag>
                    ))}
                </Flex>
                <Flex>
                    <Input
                        type="text"
                        value={tagInput}
                        onChange={updateTagInput}
                        placeholder="Add a tag"
                    />
                    <Button ml={2} onClick={addTag} colorScheme="blue">
                        Add Tag
                    </Button>
                </Flex>
            </FormControl>

            <FormControl mb={4}>
                <FormLabel>Categories</FormLabel>
                <Select
                    name="categories"
                    value={formData.categories}
                    onChange={handleChange}
                >
                    <option value="">Select a category</option>
                    <option value="Education">Education</option>
                    <option value="Entertainment">Entertainment</option>
                    <option value="Technology">Technology</option>
                    <option value="Lifestyle">Lifestyle</option>
                </Select>
            </FormControl>

            <FormControl mb={4}>
                <FormLabel>Language</FormLabel>
                <Select
                    name="language"
                    value={formData.language}
                    onChange={handleChange}
                >
                    <option value="">Select a language</option>
                    <option value="en">English</option>
                    <option value="es">Spanish</option>
                    <option value="fr">French</option>
                    <option value="de">German</option>
                </Select>
            </FormControl>

            <FormControl isRequired mb={4}>
                <FormLabel>Video File</FormLabel>
                <Input
                    type="file"
                    accept="video/*"
                    onChange={handleFileChange}
                />
            </FormControl>
        </Box>
    );
};
